import { render, staticRenderFns } from "./PlansTopTenPieChart.vue?vue&type=template&id=13cf3df8&scoped=true&"
import script from "./PlansTopTenPieChart.vue?vue&type=script&lang=js&"
export * from "./PlansTopTenPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cf3df8",
  null
  
)

export default component.exports